<template>
  <div style="margin: 10px;">
    <Button type="primary">Hello PCB</Button>
  </div>
</template>

<script  setup>
import { Button } from '@arco-design/web-vue';
defineOptions({
    name:"pcb-hello"
})
</script>

<style>

</style>